import React from 'react';

/**
 * Notes template with truncation
 */
export const NotesTemplate: React.FC<{ notes: string }> = ({ notes }) => {
  const text = notes || '';
  const truncated = text.length > 60 ? text.substring(0, 60) + '...' : text;

  return (
    <div
      style={{
        padding: '8px 4px',
        height: '100%',
        display: 'flex',
        alignItems: 'center',
      }}
    >
      <div
        style={{
          fontSize: '0.875rem',
          color: '#374151',
          lineHeight: 1.4,
          whiteSpace: 'pre-wrap',
          wordBreak: 'break-word',
        }}
      >
        {truncated || (
          <span style={{ color: '#9ca3af', fontStyle: 'italic' }}>No notes</span>
        )}
      </div>
    </div>
  );
};

export default NotesTemplate;
